/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 搭乗者ごとの情報<br>項目名は搭乗者ID
 */
export interface CheckinStatus {
  /**
   * 搭乗者毎のチェックイン状況<br> completed:搭乗者の全セグメントのチェックインステータスが\"accepted\"（チェックイン済み）<br> standbyCompleted:搭乗者の全セグメントのチェックインステータスが\"standBy\"（スタンバイチェックイン済み）<br> partiallyCompleted:搭乗者の一部のセグメントのチェックインステータスが\"notAccepted\"（未チェックイン）<br> notCompleted:搭乗者の全セグメントのチェックインステータスが\"notAccepted\"（未チェックイン）<br>
   */
  checkInStatus?: CheckinStatus.CheckInStatusEnum;
}
export namespace CheckinStatus {
  export type CheckInStatusEnum = 'completed' | 'standbyCompleted' | 'partiallyCompleted' | 'notCompleted';
  export const CheckInStatusEnum = {
    Completed: 'completed' as CheckInStatusEnum,
    StandbyCompleted: 'standbyCompleted' as CheckInStatusEnum,
    PartiallyCompleted: 'partiallyCompleted' as CheckInStatusEnum,
    NotCompleted: 'notCompleted' as CheckInStatusEnum,
  };
}
